export default "__VITE_ASSET__402e5351__"